import { CircularProgress } from "@mui/material";
import { StyledLoadingContainer } from "./styles";

const Loading = () => {
  return (
    <StyledLoadingContainer>
      <CircularProgress />
    </StyledLoadingContainer>
  );
};

export default Loading;
